<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item>
              <el-select v-model="form.type" placeholder="请选择类型">
                <el-option v-for="item in videoTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加视频
          </el-button>
          <!-- 
          <el-button class="el-primary-border" round @click="handleVideoType">
            <svg-icon icon-class="add" />&nbsp;管理视频类别
          </el-button> -->
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="视频名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="类别" show-overflow-tooltip>
            <template slot-scope="scope">{{ handleTypeId(scope.row.type) }}</template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
                         layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增视频': operation == 'edit' ? '编辑视频':'查看视频'" @close="onCancel" :close-on-click-modal="false"
                 :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入视频名称" />
          </el-form-item>

          <el-form-item class="mb-30" prop="type">
            <el-select v-model="addForm.type" :disabled="operation == 'view'" placeholder="请选择类别">
              <el-option v-for="item in videoTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="mb-30">
            <el-input v-model="videoUrl" disabled placeholder="上传视频自动获取URL" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="video/*" :data="configData"
                       :show-file-list="false" :on-progress="uploadVideoProcess" :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload">

              <video v-if="videoUrl != '' && !videoFlag" v-bind:src="videoUrl" class="w-100" controls="controls">
                您的浏览器不支持视频播放
              </video>

              <div v-else-if="videoUrl == '' && !videoFlag">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传视频</div>
              </div>

              <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent" style="margin-top: 7px"></el-progress>
            </el-upload>

            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="false" accept=".jpg,.jpeg,.png,.JPG" :data="configData"
                       :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="width: 100%;;height:150px;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传视频封面</div>
              </div>
              <div class="tip-img">建议图片大小：1600 * 900</div>

            </el-upload>
          </el-form-item>

          <!-- <el-form-item class="avatar-uploader-form">
            <div class="uploader-form" @click="uploadPicture">
              <img v-if="imgUrl" :src="imgUrl" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="tip-img" style="left: 0">建议图片大小：345 * 228</div>
            </div>
          </el-form-item> -->
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation !== 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </div>
</template>
<script>
import CropperImage from '@cmp/cropper'

export default {
  components: { CropperImage },

  data() {
    return {
      form: {
        title: ''
      },
      operation: 'add',
      addForm: {},
      rules: {
        name: [
          { required: true, message: '视频名称不能为空', trigger: 'blur' }
        ],
        type: [{ required: true, message: '视频类别不能为空', trigger: 'blur' }]
      },
      configData: {
        tableName: 'collect'
      },
      videoFlag: false,
      videoUrl: '',
      videoUploadPercent: 0,
      imgUrl: '',
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      dictCode: '',
      total: 0,
      videoTypeList: [],
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet
        .getAudioVideoList({
          ...this.form,
          type: this.dictCode,
          ...this.listQuery
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            if (res.result && res.result.records) {
              this.tableData = res.result.records
              this.total = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //封面设置
    uploadPicture(type) {
      if (this.operation == 'view') {
        return
      }
      let option = {
        cropWidth: '345',
        cropHeight: '228',
        imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    handleVideoType() {
      this.$router.push('/applet-management/video-type')
    },

    getDicData() {
      this.$http
        .get('/collectDict/getSelectDataByKey', { key: 'video_type' })
        .then((res) => {
          if (res.success) {
            var result = res.result
            this.videoTypeList = result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleTypeId(typeId) {
      let arr = this.videoTypeList.filter((item) => {
        return item.dictCode == typeId
      })
      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    },

    // 重置查询
    resetForm() {
      this.form = {
        title: ''
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = 'view'
      this.$api.applet.getAudioVideoDetail({ id: obj.id }).then((res) => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.pic) {
              this.imgUrl = res.result.pic
            }
            if (res.result.url) {
              this.videoUrl = res.result.url
            }
          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = 'add'
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = 'edit'
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.pic) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.pic}`
      }

      if (obj.url) {
        this.videoUrl = `/singleMuseum/attach/getFile?fileId=${obj.url}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.applet.delAudioVideo({ id: obj.id }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeVideoUpload(file) {
      let index = file.name.lastIndexOf('.'),
        type = file.name.slice(index + 1)
      // var isLt2M = file.size / 1024 / 1024 < 2
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }
      console.log(type)
      if (
        ['mp4', 'ogg', 'flv', 'avi', 'wmv', 'rmvb', 'mov'].indexOf(type) == -1 //控制格式
      ) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
    },

    handleVideoSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.videoFlag = false
        this.videoUploadPercent = 0
        this.videoUrl = res.result.attPath
        this.addForm.url = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    //进度条
    uploadVideoProcess(file, fileList) {
      this.videoFlag = true // 显示进度条
      this.videoUploadPercent = parseInt(file.percent)
      // //注意在data中添加对应的变量名
      // const self = this
      // if (file.status === 'ready') {
      //   this.videoFlag = true // 显示进度条
      //   this.videoUploadPercent = 0
      //   const interval = setInterval(() => {
      //     if (self.videoUploadPercent >= 99) {
      //       clearInterval(interval)
      //       return
      //     }
      //     self.videoUploadPercent += 1
      //   }, 20)
      // }
      // if (file.status === 'success') {
      //   setTimeout(() => {
      //     this.videoFlag = false // 显示进度条
      //     this.videoUploadPercent = 100
      //   }, 500)
      // }
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return false
      }

      if (
        fileType === '.jpg' ||
        fileType === '.png' ||
        fileType === '.jpeg' ||
        fileType === '.bmp' ||
        fileType === '.gif'
      ) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return false
      }
    },

    handleUploadSuccess(result) {
      this.addForm.pic = result.attId
      this.imgUrl = result.attPath
      this.cropperModel = false
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.pic = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let url = 'addAudioVideo'
          if (this.addForm.id) {
            url = 'updateAudioVideo'
          } else {
            // this.addForm.creater = this.$store.state.user.userid
            // this.addForm.updater = this.$store.state.user.userid
            // this.addForm.updateTime = new Date().getTime()
            // this.addForm.status = "0"
          }
          this.$api.applet[url](this.addForm).then((res) => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '视频修改成功' : '新增视频成功',
                duration: 500,
                onClose() {
                  self.onCancel()
                  self.getData()
                }
              })
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ''
      this.videoUrl = ''
      this.videoFlag = false
      this.$refs['form'].clearValidate()
    },
    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },
  created() {
    this.dictCode = this.$route.query.dictCode
    this.getData()
    this.getDicData()

    window.addEventListener('keyup', this.keydown)
  }
}
</script>
<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      height: 150px;
      .uploader-form {
        flex: 1;
        margin-right: 20px;
        height: 100%;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px dashed #8c939d;
        img {
          width: 100%;
          height: 100%;
        }
        i {
          font-size: 34px;
        }
      }
      .el-form-item__content {
        height: 100%;
        display: flex;
        .avatar-uploader {
          flex: 1;
          border: 1px dashed #8c939d;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &:first-child {
            margin-right: 20px;
          }
          .el-icon-plus {
            font-size: 20px;
          }

          .el-upload__text {
            line-height: 1;
          }
        }

        .el-upload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
